import React from 'react';
import {FadeIn} from './ui/FadeIn';

export function Results() {
  return (
    <section className="py-section-mob md:py-section-desk bg-paper">
      <div className="max-w-content mx-auto px-pad-mob md:px-pad-desk">
        <FadeIn>
          <div className="py-20 flex flex-col items-center text-center">
            <p className="font-heading italic text-[24px] leading-relaxed text-graphite max-w-[800px]">
              "Testimonials publishing soon. Until then, ask me on the call to walk you through specific case examples, under NDA where required."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}